import { ItemTypeMetadata } from "../item-type-metadata.enum"
import { ObjectJsonSchemaBase } from "../schema/object-json-schema.model"
import { WidgetJsonSchema } from "../schema/widget-json-schema.model"
import { ItemMetadataBase } from "./item-metadata.model"


export class TimeItemMetadataBase extends ItemMetadataBase {

    constructor(type: string) {
        super(type)
        this.defaultValue = { hours: 0, minutes: 0 }
    }

    override schema(): WidgetJsonSchema {
        let schema = new ObjectJsonSchemaBase(ItemTypeMetadata.Time)
        schema.properties['hours'] = { type: 'integer' }
        schema.properties['minutes'] = { type: 'integer' }
        schema.required.push('hours')
        schema.required.push('minutes')

        return schema
    }

}

export interface TimeItemMetadata extends TimeItemMetadataBase { }